import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './langs/zh.js';
import en from './langs/en.js';

Vue.use(VueI18n);
const i18n = new VueI18n({
    legacy: false,
    locale: localStorage.getItem('lang') || 'zh',  // 初始化配置语言
    messages:{
        zh,
        en
    },
    silentTranslationWarn: true,  // 隐藏警告
    globalInjection: true,
    fallbackLocale: 'zh'
})
const lang = localStorage.getItem('lang')
if (!lang) {
    localStorage.setItem('lang', 'zh');
}

export default i18n;